// cfgactions

const getters = {
	getCfgActions(state) {
		return state.cfgactions;
	},

};

export default getters;